





































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BasePagination from '@/base/BasePagination.vue';
import TheTableLog from '@/components/log/TheTableLog.vue';
// Importing function
import {getLog} from '@/ts/log/get-log';

export default {
    name: 'PageLog',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableLog,
    },
    props: {},
    data() {
        return {
            items: Array(),
        };
    },
    methods: {
        // Switching between pages
        switchPage(page) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setCurrentPage', page);
            getLog('', '', '').then(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Регистър на промените',
        }];
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
        this.$store.dispatch('setLastPage', 1);
        // Fetching data from the API
        this.$store.dispatch('setLoadingOn');
        getLog('', '', '').then(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
